// ---------------------------------------------------------------------------
// Block Definition: map
//
// World map with active-country shading and facility-location markers.
// LLM extraction populates active_countries, cities, country_count,
// and site_count from the source.
// ---------------------------------------------------------------------------

function nullable(type, description, extra = {}) {
  const t = Array.isArray(type) ? type : [type, "null"];
  return { type: t, ...(description ? { description } : {}), ...extra };
}

export const mapDef = {
  type: "map",
  label: "Map",
  description: "World map with active-country shading and facility markers.",

  crystallizer: {
    extractionPhases: ["llm"],

    buildDataSchema(block, opts) {
      return {
        type: "object",
        properties: {
          active_countries: {
            type: "array",
            description: "Country names where facilities exist. Use Natural Earth canonical names (e.g. 'United States of America', 'United Kingdom', 'Republic of Ireland', 'Türkiye'). Deduplicate.",
            items: { type: "string" }
          },
          cities: {
            type: "array",
            description: "Facility-location markers. One entry per distinct site. Cap at ~25 entries.",
            items: {
              type: "object",
              properties: {
                name:  { type: "string", description: "Short site label." },
                lat:   { type: "number", description: "Latitude (-90 to 90)." },
                lng:   { type: "number", description: "Longitude (-180 to 180)." },
                label: nullable("string", "Optional label rendered next to dot.")
              },
              required: ["name", "lat", "lng", "label"],
              additionalProperties: false
            }
          },
          country_count: nullable("integer", "Distinct count of countries with facilities."),
          site_count: nullable("integer", "Total number of individual sites.")
        },
        required: ["active_countries", "cities", "country_count", "site_count"],
        additionalProperties: false
      };
    },

    buildShapeDescription(block) {
      return `{ "active_countries": ["<string>",...], "cities": [{"name":"<string>","lat":<number>,"lng":<number>,"label":"<string>"},...], "country_count": <number>, "site_count": <number> }`;
    },

    isBlockLevelTarget() { return true; },
    skipFromPinSchema() { return false; },
    isCodeDerived() { return false; },
    collectHints() { return []; },
    buildPromptSupplement() { return ""; },
    postProcess(data) { return data; },
  },

  renderer: null, // wired by ui/src/blockRegistryInit.js

  editor: {
    icon: "map",
    category: "data-visualization",
    defaultTemplate: { type: "map" },
    configFields: [
      { name: "shading.active", type: "string", label: "Active country fill", defaultValue: "#1F3A2E" },
      { name: "shading.inactive", type: "string", label: "Inactive country fill", defaultValue: "#E5E0D2" },
    ],
  },
};
